import { render, staticRenderFns } from "./logisticsStock.vue?vue&type=template&id=fdbcd1d2&scoped=true"
import script from "./logisticsStock.vue?vue&type=script&lang=js"
export * from "./logisticsStock.vue?vue&type=script&lang=js"
import style0 from "./logisticsStock.vue?vue&type=style&index=0&id=fdbcd1d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbcd1d2",
  null
  
)

export default component.exports